import { isMobileOnly } from "react-device-detect";
import FPConfig from "./config";

export const isEmptyObj = (obj) => {
    return !Object.keys(obj).length;
}

export const findObj = (array, val, keyName) => {
    return array.find(element => element[keyName] === val)
}

export const findAll = (array, val, keyName) => {
    return array.filter(element => element[keyName] === val)
}

export const removeWhiteSpaces = (str) => {
    const formattedStr = str ? str.replace(/\s/g, "") : ''
    return formattedStr;
}

export const onDropAlphawithsinglespace = (event) =>{
    event.preventDefault()
}

export const email = (value) => {
    if(value===undefined || value.length===0 || value===null){
        return value
    }else{
    const result = value.match(/^([a-zA-Z]+@?)*$/g);
        return result ? result[0] : undefined
    }
}   

export const alphawithsinglespace = (value) =>{
    if(value===undefined || value.length===0 || value===null){
        return value
    }else{
    const result = value.match(/^([a-zA-Z]+\s?)*$/g);
        return result ? result[0] : undefined
    }
}

export const isValidDate = (d)  => {
    let isValid = false;
    try{

        isValid =  d instanceof Date && !isNaN(d);
    }catch(e){
        isValid = false;
    }
    return isValid;
   
  }

  export const siValidDate = (d) => {
      if(d && d != ""){
        const dateArr = d.split("-")
            let date = new Date()
            date.setDate(dateArr[0])
            date.setMonth(dateArr[1] - 1)
            date.setFullYear(dateArr[2])
            date.setHours('00')
            date.setMinutes('00')
            date.setSeconds('00')
            return date      
      } else {
           return d;
      }


  }

export const ccFormat = (value) => {
    const cardno = value.replace(/[^\d]/g, '').replace(/(.{4})/g, '$1 ').trim();
    return cardno;
}

export const allowSingleSpecialCharacter = (value) => {
    if(value===undefined || value.length===0 || value===null){
        return value
    }else{
        const result = value.match(/^[a-zA-Z0-9@]+$/g)
        return result ? result[0] : undefined
    }
}

export const numberOnly = (value) => {
    if(value===undefined || value.length===0 || value===null){
        return value
    }else{
        const result = value.match(/^[0-9\b]+$/g)
        return result ? result[0] : undefined
    }
}

export const numberAndUpdateCvv = (currentValue, updateCvv, getCvv) => {
    let value=''
    let updatedCvv=getCvv()
    if(getCvv().length>currentValue.length){ // consider deleting the cvv
        updatedCvv = getCvv().slice(0, currentValue.length)
    }
    value = updatedCvv+currentValue.replace(/•/g,"") // 'value' variable now have cvv number 
    if(value===undefined || value.length===0 || value===null){
        updateCvv('')
        return value
    }else{
        const result = value.match(/^[0-9\b]+$/g)
        const finalResult = result ? result[0] : undefined
        let dotStr='';
        if(finalResult){
            for (const [] of finalResult.split("")) {
                dotStr += "•"
            }
        }else{
            dotStr = finalResult
        }
        updateCvv(finalResult)
        return dotStr// finalResult
    }
}

export const onlyNumberAndDot = (value) => {
    if(value===undefined || value.length===0 || value===null){
        return value
    }else{
    const result = value.match(/^\d*\.?(?:\d{1,2})?$/g, '')
        return result ? result[0] : undefined
    }
}

// Length including the white space after each 4 digit
export const cardMaxLength = (cardType) => {
    // switch(cardType){
    //     case 'MAESTRO':
    //         return 23;
    //     case 'AMEX':
    //         return 18;
    //     case 'VISA':
    //         return 19;
    //     case 'MASTER':
    //         return 19;
    //     case 'RUPAY':
    //         return 19;
    //     default:
    //         return 19;
    // }
    return FPConfig.cardInitialMaxLimit;
}

// This function has been changed and mask card for display will always follow the standard pattern as 1234 XXXX 5678 irrespective of 16/15/19 digit savedcard 
export const formatCardWithSpace = (cardNumber) => {
    const card_no = removeWhiteSpaces(cardNumber)
    const getFirstFourDigit = card_no.substring(0, 4)
    const getLastFourDigit =  card_no.replace(/.(?=.{4})/g, '')
    return `${getFirstFourDigit} XXXX ${getLastFourDigit}`
}

// CVV text length is defining here for card types (The default CVV lenght should be 3 except Amex card )
export const cvvMaxLength = (cardType) => {
    switch(cardType){
        case 'AMEX':
            return 4;
        default:
            return 3;
    }
}

function rearrangeItemPossition(arr, fromIndex, toIndex){
    const element = arr[fromIndex];
    if(fromIndex===-1)
        return arr
    arr.splice(fromIndex, 1);
    arr.splice(toIndex, 0, element);
    return arr;
}

export const filterAndSortPayMenu = (paymentList) => {
    let newPaymentList = rearrangeItemPossition(paymentList, paymentList.indexOf('UPI'), 1)
    newPaymentList = rearrangeItemPossition(paymentList, newPaymentList.indexOf('SC'), 0)
    newPaymentList = newPaymentList.filter(payment => (payment!=='BHARATQR' || !(payment==='BHARATQR' && isMobileOnly)) )
    return newPaymentList
}

/* zero before day and month in date */
 export const appendLeadingZeroes = (n) => {
    if(n <= 9){
      return "0" + n;
    }
    return n
}

export const urlParam = (name) => {
    const results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
    if (results == null){
       return null;
    }
    else {
       return decodeURI(results[1]) || 0;
    }
}

export const isEmptyOrUndefined = (val) => {
    return (typeof(val)==="undefined" || val===undefined || val===null || isEmptyObj(val))
}


export const updateTheme = (themeVariables) => {
    Object.keys(themeVariables).forEach((key) => {
        const cssKey = `--${key}`;
        const cssValue = themeVariables[key]
        document.documentElement.style.setProperty(cssKey, cssValue);
    })
}

export const fpDateStrToDate = (dateStr) => {
    const dateArr = dateStr.split("-")
    return new Date(`${dateArr[2]}-${dateArr[1]}-${dateArr[0]} 00:00:00`)
}

export const fpDisplayDateStrToDate = (dateStr) => {
    const dateArr = dateStr.split("/")
    return new Date(`${dateArr[2]}-${dateArr[1]}-${dateArr[0]} 00:00:00`)
}

export const dateToFPDateStr = (date) => {
    const day = appendLeadingZeroes(date.getDate())
    const month = appendLeadingZeroes(date.getMonth()+1)
    const year = date.getFullYear()
    const formatted_date = `${day}-${month}-${year}`
    return formatted_date
}

export const fpDisplayDateStrToInt = (dateStr) => {
    const dateArr = dateStr.split("/")
    return Date.parse(`${dateArr[2]}-${dateArr[1]}-${dateArr[0]} 00:00:00`)
}

export const avoidPasting = (e) => {
    e.preventDefault();
    return false;
}

export const normalizePhone = value => {
    if (!value) {
      return value
    }
  
    const onlyNums = value.replace(/[^\d]/g, '')
    if (onlyNums.length <= 3) {
      return onlyNums
    }
    if (onlyNums.length <= 7) {
      return `+91-${onlyNums.slice(0, 3)}-${onlyNums.slice(3)}`
    }
    return `+91-${onlyNums.slice(0, 3)}-${onlyNums.slice(3, 6)}-${onlyNums.slice(
      6,
      10
    )}`
  }

export const alphaNumeric = (value) => {
    if(value === undefined || value.length === 0 || value === null){
        return value
    } else {
    const result = value.match(/^[a-zA-Z0-9 ]*$/g);
        return result ? result[0] : undefined
    }
}

export const alphaNumericSpecial = (value) => {
    if(value === undefined || value.length === 0 || value === null){
        return value
    } else {
    const result = value.match(/^[A-Za-z0-9_@#&\/.\- ]*$/g);
        return result ? result[0] : undefined
    }
}